/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */

import {
	Dialog,
	DialogContent,
	DialogTitle,
	Button,
	DialogActions,
	Box,
	FormControl,
	InputLabel,
	Select,
	MenuItem
} from "@material-ui/core";
import i18n from "i18next";
import React, { useEffect, useState } from "react";
import lod_, { cloneDeep, set } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import cockpitActions from "../../../redux/actions/cockpitActions";
import { errorMsg } from "redux/reducers/snackMsgsReducers";
import InputType from "./InputType";
import { regexMail } from "helpers/utilities";
import { validatePhone } from "helpers/utilities";
import { isValid } from "date-fns";

/**
 * Form specific: Build input with type and options given
 */
function ActionFormChoiceURL({ code, actionObject, handleClose, handleSubmit }) {
	const [open, setOpen] = React.useState(false);
	const { selectedConversation } = useSelector(state => state.cockpit);
	const dispatch = useDispatch();

	const [valueChoices, setValueChoices] = useState([]);
	const [choice, setChoice] = useState(null);

	useEffect(() => {
		if (!lod_.isEmpty(actionObject?.config?.pathContext)) {
			const valueContext = lod_.get(selectedConversation, actionObject.config.pathContext);
			if (!lod_.isNil(valueContext)) {
				const filterType = actionObject?.config?.filterChoice;
				const filteredChoices = lod_.isArray(valueContext)
					? valueContext.filter(item => {
							if (lod_.isEmpty(filterType)) return true;
							if (lod_.isArray(filterType)) return filterType.includes(item?.type);
							return item?.type === filterType;
						})
					: [];
				setValueChoices(filteredChoices);
			}
			setOpen(true);
		} else {
			dispatch(errorMsg(i18n.t(`COC.actionForm.noConfigFoundAction`)));
			handleClose();
		}
	}, []);

	const handleChangeChoice = choice => {
		setChoice(choice);
	};

	return (
		<Dialog
			fullWidth={true}
			onClose={handleClose}
			maxWidth={"sm"}
			open={open}
			aria-labelledby="form-dialog-title"
		>
			<DialogTitle id="form-dialog-title">{actionObject.name}</DialogTitle>
			<DialogContent dividers>
				{lod_.isEmpty(valueChoices) ? (
					<Box style={{ display: "flex", justifyContent: "center", width: "100%" }}>
						{i18n.t("COC.actionForm.emptyPaymentMethod")}
					</Box>
				) : (
					<Box pt={2}>
						<FormControl variant="outlined" fullWidth>
							<InputLabel id="action-choice-url-label">
								{i18n.t("COC.actionForm.chooseValue")}
							</InputLabel>
							<Select
								labelId="action-choice-url-label"
								id="action-choice-url"
								label="URL"
								value={choice}
								onChange={e => handleChangeChoice(e.target.value)}
							>
								{valueChoices.map((choice, index) => (
									<MenuItem key={index} value={choice.value}>
										{choice.label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Box>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} style={{ margin: "2%" }} color="secondary">
					{i18n.t("CD.cancel")}
				</Button>
				<Button
					onClick={() =>
						handleSubmit(
							{
								choice
							},
							code,
							actionObject
						)
					}
					style={{ margin: "2%" }}
					color="primary"
					disabled={lod_.isEmpty(choice)}
				>
					{i18n.t("CD.validate")}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ActionFormChoiceURL;
